import React from 'react'
import Exchange from "./S1_Swap/Swap"
import { PageWrapper } from "../../Styles/style"
const index = () => {
    return (
        <div>
            <PageWrapper>
                <Exchange />
            </PageWrapper>
        </div>
    )
}

export default index